import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
    findPopularityList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`popularity/findPopularityList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findPopularityInformationList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`popularity/findPopularityInformationList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  
  findSeachList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`popularity/findSeachList`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
